module.exports = __webpack_public_path__ + "img/reportNull.d2e10341.png";